"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GasMeterReadingFormLegacy = exports.gasIds = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importStar(require("react"));
var core_1 = require("../../../shared/core");
var analytics_subjects_1 = require("../analytics-subjects");
var copy_1 = require("../copy");
var utils_1 = require("../pages/SubmitMeterReading/utils");
var MeterReadsDatepicker_1 = require("./MeterReadsDatepicker");
exports.gasIds = {
    gasMeterReadingId: 'meter-reading',
    dateId: 'gas-date',
};
var GasMeterReadingFormLegacy = function (_a) {
    var _b;
    var currentSupply = _a.currentSupply, fuel = _a.fuel, errors = _a.errors, isUpdating = _a.isUpdating, onSubmit = _a.onSubmit;
    var _c = (0, core_1.useCopy)(copy_1.defaultOptions), copy = _c.copy, Copy = _c.Copy;
    var _d = __read((0, react_1.useState)(''), 2), meterReading = _d[0], setMeterReading = _d[1];
    var _e = (0, core_1.useComponents)(), NumberField = _e.NumberField, PrimaryCTAButton = _e.PrimaryCTAButton, Stack = _e.Stack, Notification = _e.Notification;
    var _f = __read((0, react_1.useState)(''), 2), date = _f[0], setDate = _f[1];
    if (!currentSupply.mpxn) {
        react_1.default.createElement(Notification, { "data-testid": "no-msn-notification", id: "no-msn" },
            react_1.default.createElement(Copy, { copyKey: "noMsn" }));
    }
    var onMeterReadingChange = function (_a) {
        var _b = _a.currentTarget, meterReading = _b.value, maxLength = _b.maxLength;
        if (maxLength > -1 && meterReading.replace('.', '').length > maxLength) {
            return;
        }
        setMeterReading(meterReading);
    };
    var handleSubmit = function (event) {
        event.preventDefault();
        var body = {
            mpxn: currentSupply.mpxn || '',
            gasVolume: meterReading === '' ? null : Number(meterReading),
            readingDateTime: (0, utils_1.getReadingDateTime)(date),
        };
        onSubmit(body);
    };
    var meterReadingInputLabel = !currentSupply.isInOMRWindow
        ? copy('readingSingleInputLabel', { fuel: fuel })
        : copy('readingSingleInputLabelToday', { fuel: fuel });
    return (react_1.default.createElement("form", { key: fuel, onSubmit: handleSubmit, method: "POST", noValidate: true },
        react_1.default.createElement(Stack, { spaceBetween: [4, 8] },
            react_1.default.createElement(NumberField, { "data-testid": exports.gasIds.gasMeterReadingId, id: exports.gasIds.gasMeterReadingId, label: meterReadingInputLabel, value: meterReading, onChange: onMeterReadingChange, hint: errors &&
                    errors.gasMeterReadingId !== copy('readingSingleInputHintText') &&
                    copy('readingSingleInputHintText'), error: errors === null || errors === void 0 ? void 0 : errors.gasMeterReadingId, characters: 6, disabled: isUpdating }),
            !currentSupply.isInOMRWindow ? (react_1.default.createElement(MeterReadsDatepicker_1.MeterReadsDatepicker, { id: exports.gasIds.dateId, supplyStartDate: currentSupply.start, setDate: setDate, fuel: "gas", error: errors === null || errors === void 0 ? void 0 : errors.dateId })) : null,
            react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.SUBMIT_METER_READING, properties: (_b = {
                        meterData: (0, utils_1.getMeterReadAnalyticsData)(currentSupply, 'gas'),
                        backdatedDays: (0, utils_1.getBackdatedDaysToToday)(date),
                        datepickerEntry: date
                    },
                    _b[core_1.INTERNAL_EVENT_FLAG] = true,
                    _b) },
                react_1.default.createElement(PrimaryCTAButton, { type: "submit", disabled: isUpdating, "data-testid": "submit-meter-reading" },
                    react_1.default.createElement(Copy, { copyKey: "readingSubmitLabel", values: { fuel: fuel } }))))));
};
exports.GasMeterReadingFormLegacy = GasMeterReadingFormLegacy;
